// Чат-вид тикета: список сообщений + автопрокрутка вниз при новых.
import React, { useEffect, useRef } from "react";
import TicketMessageItem from "./TicketMessageItem";

export default function TicketChatView({ messages }) {
  const bottomRef = useRef(null);
  const prevCountRef = useRef(0);

  useEffect(() => {
    // Прокручиваем только когда добавились новые сообщения
    // (а не при первой пустой загрузке).
    if (messages.length > prevCountRef.current) {
      bottomRef.current && bottomRef.current.scrollIntoView({ behavior: "smooth" });
    }
    prevCountRef.current = messages.length;
  }, [messages]);

  if (!messages || messages.length === 0) {
    return (
      <div className="sup-msg-info">
        В этом обращении пока нет сообщений.
      </div>
    );
  }

  return (
    <>
      {messages.map((m) => (
        <TicketMessageItem key={m.id} message={m} />
      ))}
      <div ref={bottomRef} />
    </>
  );
}
